(function () {
    /* tabs-with-products */
    if($('.tabs-with-products .twp__content-item .twp__video')){
        $('.tabs-with-products .twp__content-item .twp__video video').each(function(index, value){
            $(this).get(0).pause();
        });
        $('.tabs-with-products .twp__content-item').hover(function(){
            $(this).find("video").get(0).play();
        }, function(){
            $(this).find("video").get(0).pause();
        });
    }
    /* end tabs-with-products */
	if($('body').hasClass('template-page-colette')){
        $('.collapsible-content__items').each(function(index, value){
            $(this).find('.collapsible-content__item').removeClass('active').find('.collapsible-content__answer').hide();
        });
    }

    if($('.subscribe-newsletter .btn-newsletter-subscribe').length > 0)
    {
        $('.subscribe-newsletter .btn-newsletter-subscribe').on('click', function (e) 
        {
            e.preventDefault();
            var $el = $(this);
            var newsletterContainer = $(this).parent();
            var customerName = $.trim(newsletterContainer.find("input").val());
            newsletterContainer.find(".error_name").addClass("hidden");
            newsletterContainer.find(".error_server").addClass("hidden");
            if(customerName == "")
            {
                newsletterContainer.find(".error_name").removeClass("hidden");
            }
            else{
                console.log("ddd");
                $el.addClass("loading");
                $el.attr('disabled','disabled');
                try 
                {
                    console.log("fff");
                    const response = fetch('https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/newsletter.php', 
                    {
                        method: "POST",
                        body: JSON.stringify({
                            id: $(newsletterContainer).data("customer-id"),
                            name: customerName,
                            lang: $(newsletterContainer).data("lang")
                        })
                    });
                    response.then(res => {
                        return res.json();
                    })
                    .then(res => {
                        $el.removeAttr('disabled');
                        $el.removeClass("loading");
                        if(res.status){
                            window.location.href = window.location.href;
                        }
                        else{
                            newsletterContainer.find(".error_server").removeClass("hidden");
                        }
                        
                    });
                } catch (error) {
                    console.log(error);
                    $el.removeAttr('disabled');
                    $el.removeClass("loading");
                    newsletterContainer.find(".error_server").removeClass("hidden");
                }
            }
        });
    }

    document.querySelectorAll('a[href="/collections/cards"]').forEach(link => {
      link.href = "/pages/dw-cards";
    });

    document.querySelectorAll('a[href="/collections/mentorship"]').forEach(link => {
      link.href = "/pages/mentorship";
    });

    document.querySelectorAll('a[href="/pt/collections/cards"]').forEach(link => {
      link.href = "/pt/pages/dw-cards";
    });

    document.querySelectorAll('a[href="/pt/collections/mentorship"]').forEach(link => {
      link.href = "/pt/pages/mentorship";
    });

    const footerLanguageSelect = document.querySelector('.footer__localization');
    if(footerLanguageSelect){
        footerLanguageSelect.innerHTML = footerLanguageSelect.innerHTML.replace(/\bbrasil\b/gi, 'Brasil');
    }
    

})();